/*
 * @Author: DouDou
 * @LastEditors: DouDou
 * @Date: 2020-09-11 12:16:44
 * @LastEditTime: 2020-10-09 09:43:37
 * @Description: 3.2之后的老带新代码优化（模块重构）
 */
import Vue from 'vue'
import api from './api'
import App from './App.vue'
import router from './router'
import store from './store' // 学而思热点包 （埋点）
import '@/inviteNew/assets/scss/index.scss' // 全局样式引入 （后期会逐一删除便于开发）
import { XesCookie, XesChannel, XesShare, XesTalLogin, XesLoggerSDK } from '@xes/terra-utils'
import { Toast, Dialog, Popup, Picker, Swipe, SwipeItem, Tab, Tabs, Button, NoticeBar, List } from 'vant'

Vue.use(Tab)
  .use(Tabs)
  .use(List)
  .use(Toast)
  .use(Popup)
  .use(Swipe)
  .use(Button)
  .use(Dialog)
  .use(Picker)
  .use(NoticeBar)
  .use(SwipeItem)

window.xesCookie = XesCookie
// 公共分享
window.xesShare = new XesShare()
// 获取取到信息
window._wltfChannel = new XesChannel()

// 全局引入公用方法
Vue.prototype.$api = api
Vue.config.productionTip = false
Vue.prototype.$xesCookie = XesCookie
Vue.prototype.$xesTalLogin = new XesTalLogin({
  env: window._wltfChannel.urlParams.env
})

if (process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line
  const eruda = require('eruda')
  eruda.init()
}

// vue新版日志初始化
Vue.use(XesLoggerSDK, {
  logAppid: '1001132',
  common: {
    eventid: 'inviteNew'
  },
  loadMsg: {
    open: true
  },
  hashchange: {
    open: true,
    pvid: 'hash',
    pageuid: {
      index: '5.1.0',
      register: '5.2.0',
      registerYear: '5.0',
      discountYear: '7.0',
      registerAutumn: '5.5.0',
      sharepage: '5.3.0',
      courseExchange: '12',
      discount: '5.4.0',
      discountAutumn: '5.6.0',
      rewardPage: '5.7.0',
      newSuccessList: '11',
      details: '5',
      rules: '6',
      savePoster: '8',
      posterList: '9',
      saveSelfPoster: '10',
      resubnitSelectGrade: '2',
      registerResubmit: '1',
      explosiveProduct: '1'
    }
  },
  param: {
    origin: window._wltfChannel.urlParmas.origin || 0,
    sourceid: window._wltfChannel.hotUrlParams.source || window._wltfChannel.urlParmas.source_id || ''
  }
})

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
